import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/application/app/(provider)/Provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/application/mock/MswComponent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/application/shared/@common/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/script.js");
